(function () {
  'use strict';

  const STORAGE_KEY = 'shopify_wishlist';
  const EVENT_CHANGE = 'wishlist:change';

  const Store = {
    get() {
      try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
      catch (e) { return []; }
    },
    set(handles) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
      document.dispatchEvent(new CustomEvent(EVENT_CHANGE, { detail: { handles } }));
    },
    has(handle) { return this.get().includes(handle); },
    toggle(handle) {
      const items = this.get();
      const idx = items.indexOf(handle);
      if (idx > -1) items.splice(idx, 1);
      else items.unshift(handle);
      this.set(items);
      return idx === -1;
    },
    remove(handle) { this.set(this.get().filter(h => h !== handle)); },
  };

  function syncButtons() {
    const items = Store.get();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(btn => {
      const active = items.includes(btn.dataset.productHandle);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute('aria-label', active ? 'Видалити з обраного' : 'Додати в збережене');
      const add = btn.querySelector('[data-wishlist-label-add]');
      const rem = btn.querySelector('[data-wishlist-label-remove]');
      if (add && rem) { add.hidden = active; rem.hidden = !active; }
    });
  }

  function syncCount() {
    const n = Store.get().length;

    document.querySelectorAll('[data-wishlist-count]').forEach(el => {
      if (el.textContent !== String(n)) el.textContent = n;
      el.classList.toggle('is-empty', n === 0);
    });

    const wishlistIcon = document.getElementById('WishlistDrawerTrigger');
    if (wishlistIcon) {
      wishlistIcon.classList.toggle('has-wishlist-items', n > 0);
    }
  }

  function openWishlistDrawer() {
    const trigger = document.getElementById('WishlistDrawerTrigger');
    if (trigger) trigger.click();
  }

  document.addEventListener('click', async (e) => {
    const toggleBtn = e.target.closest('[data-wishlist-toggle]');
    if (toggleBtn) {
      e.preventDefault();
      Store.toggle(toggleBtn.dataset.productHandle);
      return;
    }

    if (e.target.closest('[data-wishlist-open]')) {
      e.preventDefault();
      openWishlistDrawer();
      return;
    }

    const removeBtn = e.target.closest('[data-wishlist-remove]');
    if (removeBtn) {
      e.preventDefault();
      Store.remove(removeBtn.dataset.handle);
      return;
    }

    const cartBtn = e.target.closest('[data-wishlist-add-to-cart]');
    if (cartBtn && !cartBtn.disabled) {
      e.preventDefault();
      const id = cartBtn.dataset.variantId;
      cartBtn.disabled = true;
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id, quantity: 1 }] }),
        });
        document.dispatchEvent(new CustomEvent('cart:refresh'));

        const wlDialog = document.getElementById('WishlistDrawer');
        if (wlDialog && wlDialog.open) wlDialog.close();

        const cartDrawer = document.querySelector('cart-drawer-component');
        if (cartDrawer && typeof cartDrawer.refresh === 'function') {
          cartDrawer.refresh();
          const cartTrigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
          if (cartTrigger) setTimeout(() => cartTrigger.click(), 100);
        } else {
          setTimeout(() => window.location.reload(), 300);
        }
      } catch (err) {
        cartBtn.disabled = false;
      }
    }
  });

  const cache = new Map();

  async function fetchProduct(handle) {
    if (cache.has(handle)) return cache.get(handle);
    try {
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) throw new Error('not found');
      const data = await res.json();
      cache.set(handle, data);
      return data;
    } catch (e) { return null; }
  }

  function formatMoney(cents) {
    if (window.Shopify && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, (window.theme && window.theme.moneyFormat) || '{{amount}} ₴');
    }
    return (cents / 100).toLocaleString('uk-UA') + ' ₴';
  }

  async function renderWishlistGrid() {
    const grid = document.querySelector('[data-wishlist-grid]');
    const empty = document.querySelector('[data-wishlist-empty]');
    if (!grid) return;

    const handles = Store.get();
    grid.innerHTML = '';

    if (!handles.length) {
      if (empty) empty.hidden = false;
      grid.hidden = true;
      return;
    }
    if (empty) empty.hidden = true;
    grid.hidden = false;

    const products = await Promise.all(handles.map(fetchProduct));

    products.forEach((p, i) => {
      const handle = handles[i];
      if (!p) { Store.remove(handle); return; }

      const img = p.featured_image || (p.images && p.images[0]) || '';
      const isNew = (p.tags || []).some(t => String(t).toLowerCase() === 'new');
      const variantId = p.variants && p.variants[0] ? p.variants[0].id : '';

      const card = document.createElement('div');
      card.className = 'wishlist-card';
      card.innerHTML = `
        <div class="wishlist-card__media">
          ${isNew ? '<span class="wishlist-card__badge">NEW</span>' : ''}
          <button type="button" class="wishlist-card__heart" data-wishlist-remove data-handle="${handle}" aria-label="Видалити з обраного">
            <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" aria-hidden="true">
              <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
            </svg>
          </button>
          <a href="${p.url}">
            ${img ? `<img src="${img}" alt="${p.title}" loading="lazy">` : ''}
          </a>
          <button type="button" class="wishlist-card__cart" data-wishlist-add-to-cart data-variant-id="${variantId}" aria-label="В кошик" ${p.available ? '' : 'disabled'}>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M2.83203 14.5V4.11667H5.3737C5.3737 3.39444 5.63075 2.77778 6.14486 2.26667C6.65898 1.75556 7.27703 1.5 7.99903 1.5C8.72103 1.5 9.33898 1.75622 9.85286 2.26867C10.3668 2.78111 10.6237 3.39711 10.6237 4.11667H13.1654V14.5H2.83203ZM4.08203 13.25H11.9154V5.36667H10.6237V7.36667H9.3737V5.36667H6.6237V7.36667H5.3737V5.36667H4.08203V13.25ZM6.6237 4.11667H9.3737C9.3737 3.73889 9.23909 3.41667 8.96986 3.15C8.70064 2.88333 8.37703 2.75 7.99903 2.75C7.62103 2.75 7.29731 2.88383 7.02786 3.1515C6.75842 3.41906 6.6237 3.74078 6.6237 4.11667Z" fill="#101821"></path>
            </svg>
          </button>
        </div>
        <div class="wishlist-card__info">
          <a href="${p.url}" class="wishlist-card__title">${p.title}</a>
          <div class="wishlist-card__price">${formatMoney(p.price)}</div>
        </div>
      `;
      grid.appendChild(card);
    });
  }

  document.addEventListener(EVENT_CHANGE, () => {
    syncButtons();
    syncCount();
    const dialog = document.getElementById('WishlistDrawer');
    if (dialog && dialog.open) renderWishlistGrid();
  });

  window.addEventListener('storage', (e) => {
    if (e.key === STORAGE_KEY) document.dispatchEvent(new CustomEvent(EVENT_CHANGE));
  });

  const init = () => {
    syncButtons();
    syncCount();
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);

  const observer = new MutationObserver(() => syncCount());
  observer.observe(document.body, { childList: true, subtree: true });

  window.Wishlist = {
    open: openWishlistDrawer,
    store: Store,
    render: renderWishlistGrid,
  };
})();